import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach demo token from localStorage as Bearer fallback (in case cookie is blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ths_session_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const UGX = (n) => `UGX ${Math.round(Number(n) || 0).toLocaleString()}`;

export const ROLE_META = {
  receptionist:   { label: "Reception",         home: "/app/reception" },
  doctor:         { label: "Doctor",            home: "/app/doctor" },
  nurse:          { label: "Nurse",             home: "/app/nurse" },
  lab_tech:       { label: "Laboratory",        home: "/app/lab" },
  pharmacist:     { label: "Pharmacy",          home: "/app/pharmacy" },
  cashier:        { label: "Billing",           home: "/app/billing" },
  hospital_admin: { label: "Hospital Admin",    home: "/app/admin" },
  cfo:            { label: "Finance",           home: "/app/finance" },
  radiologist:    { label: "Radiology",         home: "/app/imaging" },
  super_admin:    { label: "Super Admin",       home: "/app/super-admin" },
};
